import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'

import PhotoCameraIcon from '@mui/icons-material/PhotoCamera'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'

import JanReader from 'components/JanReader'
import { deleteDoc, setDoc, updateDoc } from 'lib/firestore'
import { categories } from 'utils/constant'

export default function StockDialog({ data, onClose }) {
  const {
    control,
    formState: { errors, isSubmitting },
    handleSubmit,
    setValue,
  } = useForm({ defaultValues: data })
  const [open, setOpen] = useState(false)
  const [readerOpen, setReaderOpen] = useState(false)

  useEffect(() => {
    setOpen(true)
  }, [])

  const onSubmit = values => {
    values.price = parseInt(values.price)
    if (data.id) {
      return updateDoc(`products/${data.id}`, values).then(() => setOpen(false))
    } else {
      return setDoc(`products/${values.code}`, values).then(() => setOpen(false))
    }
  }

  const handleDelete = async () => {
    await deleteDoc(`products/${data.id}`)
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)} TransitionProps={{ onExited: onClose }}>
      <DialogTitle>商品登録</DialogTitle>
      <DialogContent>
        <Controller
          name="code"
          defaultValue=""
          rules={{ required: true }}
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              required
              label="JANコード"
              autoComplete="off"
              sx={{ mb: 2 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setReaderOpen(true)}
                      onMouseDown={event => event.preventDefault()}
                    >
                      <PhotoCameraIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              error={Boolean(errors.code)}
              helperText={Boolean(errors.code) && '必須項目です'}
            />
          )}
        />
        <Controller
          name="name"
          defaultValue=""
          rules={{ required: true }}
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              required
              label="商品名"
              autoComplete="off"
              sx={{ mb: 2 }}
              error={Boolean(errors.name)}
              helperText={Boolean(errors.name) && '必須項目です'}
            />
          )}
        />
        <Controller
          name="category"
          control={control}
          defaultValue={categories[0]}
          render={({ field }) => (
            <TextField
              {...field}
              label="カテゴリー"
              sx={{ mb: 2 }}
              select
              SelectProps={{ native: true }}
            >
              {categories.map(x => (
                <option key={x}>{x}</option>
              ))}
            </TextField>
          )}
        />
        <Controller
          name="standard"
          defaultValue=""
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="規格"
              placeholder="○個入り・○枚入り・○○味"
              autoComplete="off"
              sx={{ mb: 2 }}
            />
          )}
        />
        <Controller
          name="price"
          defaultValue=""
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              type="number"
              label="単価"
              autoComplete="off"
              sx={{ mb: 2 }}
              error={Boolean(errors.price)}
              helperText={Boolean(errors.price) && '必須項目です'}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        {data.id && (
          <Button color="secondary" onClick={handleDelete}>
            削除する
          </Button>
        )}
        <div style={{ flex: 1 }} />
        <Button color="primary" onClick={() => setOpen(false)} disabled={isSubmitting}>
          キャンセル
        </Button>
        <Button color="primary" onClick={handleSubmit(onSubmit)} disabled={isSubmitting}>
          {data.id ? '更新する' : '登録する'}
        </Button>
      </DialogActions>
      <JanReader
        open={readerOpen}
        onClose={() => setReaderOpen(false)}
        onDetect={code => setValue('code', code)}
      />
    </Dialog>
  )
}
